module.exports = __webpack_public_path__ + "img/google04.1b8e136b.jpg";